var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.012,
    height: 97.996,
    viewBox: "0 0 98.012 97.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7347",
    "data-name": "Group 7347",
    transform: "translate(11293 9438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M44.791,96.255l-5.979-5.978a1.594,1.594,0,0,0-1.62-.437l-8.169,2.187a5.965,5.965,0,0,1-7.3-4.212l-2.188-8.166a1.592,1.592,0,0,0-1.188-1.187L10.18,76.275a5.969,5.969,0,0,1-4.214-7.3l2.189-8.166a1.6,1.6,0,0,0-.437-1.624L1.741,53.209a5.965,5.965,0,0,1,0-8.425l5.98-5.978a1.6,1.6,0,0,0,.434-1.625L5.966,29.016a5.969,5.969,0,0,1,4.214-7.3l8.168-2.188a1.592,1.592,0,0,0,1.188-1.187l2.188-8.166a5.964,5.964,0,0,1,7.3-4.212l8.169,2.187a1.6,1.6,0,0,0,1.62-.438l5.979-5.978A5.936,5.936,0,0,1,48.818,0h.377a5.932,5.932,0,0,1,4.027,1.737L59.2,7.716a1.593,1.593,0,0,0,1.625.438l8.167-2.188a5.963,5.963,0,0,1,7.3,4.212l2.187,8.166A1.593,1.593,0,0,0,79.66,19.53l8.171,2.187a5.971,5.971,0,0,1,4.213,7.3L89.85,37.189a1.607,1.607,0,0,0,.44,1.616l5.979,5.979a5.964,5.964,0,0,1,0,8.425L90.29,59.187a1.608,1.608,0,0,0-.44,1.616l2.194,8.174a5.97,5.97,0,0,1-4.213,7.3L79.66,78.462a1.592,1.592,0,0,0-1.187,1.187l-2.187,8.165a5.963,5.963,0,0,1-7.3,4.212L60.82,89.839a1.594,1.594,0,0,0-1.625.438l-5.975,5.978a5.973,5.973,0,0,1-8.43,0Z",
    transform: "translate(-11293 -9438)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11000",
    "data-name": "Path 11000",
    d: "M38.631-12.786,23.672-47.94H16.591L1.632-12.786H9.461l3.191-7.829h14.76L30.6-12.786ZM24.669-27.4H15.395l4.637-11.319Zm25.176,14.61v-34.9H42.166v34.9Z",
    transform: "translate(-11274.632 -9359.06)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAi);
export default __webpack_public_path__ + "static/media/icon-ai.d993bb0a8959aab15eb55c6bf91a1ff0.svg";
export { ForwardRef as ReactComponent };